import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface DispatchKPIDataCountInterface {
  partnerCodes?: any
  fulfillmentOrderTypes?: any
  fromDate?: any
  toDate?: any
}

export const useGetDispatchKPIDataCount = () => {
  const mutate = useMutation(
    ({
      partnerCodes,
      fulfillmentOrderTypes,
      fromDate,
      toDate,
    }: DispatchKPIDataCountInterface) => {
      return postAPI(`MWDashboard/GetDispatchedKPIDetails`, {
        partnerCodes: partnerCodes || [],
        fulfillmentOrderTypes: fulfillmentOrderTypes || [],
        fromDate: fromDate || '',
        toDate: toDate || '',
      })
    },
  )

  return mutate
}

export default useGetDispatchKPIDataCount
